import { useTranslation } from 'react-i18next';
import { Navigate, useParams } from 'react-router-dom';

import GoBackToPcfListButton from '../../../../../../../../../footprint-details/components/go-back-to-pcf-list-button/GoBackToPcfListButton';
import CalculationTable from './components/calculation-table/CalculationTable';

const CalculationsOverview = (): JSX.Element => {
  const params = useParams() as { productId: string; footprintId: string };
  const { t } = useTranslation();

  if (!params.productId || !params.footprintId) {
    // Redirect to a 404 page
    return <Navigate to='/404' />;
  }

  const { productId, footprintId } = params;

  return (
    <div>
      <GoBackToPcfListButton url={`/products/${productId}/pcf`} />
      <h1 className='text-xl md:text-2xl font-medium p-0 my-3'>
        {t('calculationsPage.calculationPageHeader')}
      </h1>
      <CalculationTable productId={productId} footprintId={footprintId} />
    </div>
  );
};

export default CalculationsOverview;
